/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VenueList } from './VenueList';
import {
    VenueListFromJSON,
    VenueListFromJSONTyped,
    VenueListToJSON,
    VenueListToJSONTyped,
} from './VenueList';

/**
 * 
 * @export
 * @interface PaginatedVenueListList
 */
export interface PaginatedVenueListList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedVenueListList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedVenueListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedVenueListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<VenueList>}
     * @memberof PaginatedVenueListList
     */
    results: Array<VenueList>;
}

/**
 * Check if a given object implements the PaginatedVenueListList interface.
 */
export function instanceOfPaginatedVenueListList(value: object): value is PaginatedVenueListList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedVenueListListFromJSON(json: any): PaginatedVenueListList {
    return PaginatedVenueListListFromJSONTyped(json, false);
}

export function PaginatedVenueListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedVenueListList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(VenueListFromJSON)),
    };
}

  export function PaginatedVenueListListToJSON(json: any): PaginatedVenueListList {
      return PaginatedVenueListListToJSONTyped(json, false);
  }

  export function PaginatedVenueListListToJSONTyped(value?: PaginatedVenueListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(VenueListToJSON)),
    };
}

